<template>
  <div class="device-list-container">
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <div class="device-list-content">
      <el-tabs v-model="activeTab" type="border-card" class="full-height-tabs">
        <el-tab-pane label="纳管设备列表" name="managed">
          <managed-devices class="full-height-content"></managed-devices>
        </el-tab-pane>
        <el-tab-pane label="非纳管设备列表" name="non-managed">
          <non-managed-devices class="full-height-content"></non-managed-devices>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import topLine from "@/components/save-common/topLine.vue";
import ManagedDevices from './devices-list'
import NonManagedDevices from './non-managed-devices'

export default {
  name: 'DeviceList',
  components: {
    ManagedDevices,
    NonManagedDevices
  },
  data() {
    return {
      pageTitle: '设备列表',
      activeTab: 'managed'
    }
  }
}
</script>

<style scoped>
.device-list-container {
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
}

.device-list-content {
  flex: 1;
  padding: 20px;
  background: #fff;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.full-height-tabs {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.full-height-tabs ::v-deep .el-tabs__content {
  flex: 1;
  overflow: auto;
  min-height: 0;
}

.full-height-tabs ::v-deep .el-tab-pane {
  height: 100%;
}

.full-height-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.full-height-tabs ::v-deep .el-tabs__item {
  font-size: 16px;
  font-weight: 500;
}

.full-height-tabs ::v-deep.el-tabs--border-card {
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
}
</style>